import React from 'react';
import { getRoundById } from 'general/js/helpers';
import ArrayHelper from 'foundation/array-helper';
import classNames from 'classnames';
import { SitecoreImageField } from 'components/sitecore-fields';
import CustomEventLeaderboardNameColumn from './custom-event-leaderboard-name-column';
import CustomEventLeaderboardPlayersColumn from './custom-event-leaderboard-players-column';
import CustomEventLeaderboardScoreToParColumn from './custom-event-leaderboard-score-to-par-column';
import CustomEventLeaderboardHoleByHoleWidget from './custom-event-leaderboard-hole-by-hole-widget';
import CustomEventLeaderboardTeeTimeGroup from './custom-event-leaderboard-tee-time-group';

const CustomEventLeaderboardRows = (
    {
        options,
        currentRound,
        players,
        isPointsBased
    }
) => {
    const renderRows = (playersList) => {
        return playersList.map((player) => {
            const scoringPlayerRound = getRoundById(player.rounds, currentRound);
            const playerSitecoreData = player.sitecoreData;
            const isChampion = (playerSitecoreData !== null && playerSitecoreData !== undefined) ? playerSitecoreData.isChampion : false;
            const hasBonusPoints = scoringPlayerRound && scoringPlayerRound.info.some((holeInfo) => holeInfo.playerBonus >= 0);

            return (
                <div className='custom-event-leaderboard__item' key={player.id}>
                    <div className='custom-event-leaderboard__alphalist'>
                        {
                            isChampion &&
                            <div className='custom-event-leaderboard__is-champion'>
                                <SitecoreImageField img={options.customEventLeaderboardDatasource.championConfiguration.championBackgroundImage} />
                            </div>
                        }
                        <CustomEventLeaderboardNameColumn options={options.customEventLeaderboardDatasource} player={playerSitecoreData} />
                        {
                            options.customEventLeaderboardDatasource.isTeamEvent &&
                            <div className="custom-event-leaderboard__player-list">
                                <CustomEventLeaderboardPlayersColumn playersList={playerSitecoreData} />
                            </div>
                        }
                        <CustomEventLeaderboardTeeTimeGroup scoringPlayerRound={scoringPlayerRound} />
                    </div>
                    <div className={classNames(
                        'custom-event-leaderboard__score-card',
                        {
                            'custom-event-leaderboard__score-card--has-bonus': hasBonusPoints && isPointsBased,
                            'custom-event-leaderboard__score-card--no-bonus': !hasBonusPoints || !isPointsBased
                        }
                    )}>
                        {
                            hasBonusPoints && isPointsBased &&
                            <div className='custom-event-leaderboard__bonus-points-label'>{options.customEventLeaderboardDatasource.bonusPointsLabel}</div>
                        }
                        <div className='custom-event-leaderboard__pts-label'>
                            POINTS
                        </div>
                        {
                            (options.customEventLeaderboardHolesToBePlayed !== null && !ArrayHelper.isEmpty(options.customEventLeaderboardHolesToBePlayed)) &&
                            <CustomEventLeaderboardHoleByHoleWidget
                                holesToBePlayed={options.customEventLeaderboardHolesToBePlayed}
                                isScrollable={true}
                                scoringPlayerRound={scoringPlayerRound}
                                playerSitecoreData={playerSitecoreData}
                                isPointsBased={isPointsBased}
                            ></CustomEventLeaderboardHoleByHoleWidget>
                        }
                        <CustomEventLeaderboardScoreToParColumn playerScoreToPar={player.toPar} playerScore={player.toScore} isPointsBased={isPointsBased} hasBonusPoints={hasBonusPoints} />
                    </div>
                </div>
            );
        });
    };

    return (
        <React.Fragment>
            {renderRows(players)}
        </React.Fragment>
    );
};

export default CustomEventLeaderboardRows;
